import { AxiosError } from 'axios';
import { PUT_GSC_REUPLOAD_FILE_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PutReUploadExcelFile {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutReUploadExcelFile = ({ onSuccess, onError }: Input) => {
  const putReUploadExcelFile = async (payload: PutReUploadExcelFile) => {
    const res = await axiosClient.put<undefined>(PUT_GSC_REUPLOAD_FILE_URL(payload.uuid));
    return res.data;
  };

  return useCustomMutation(putReUploadExcelFile, {
    onSuccess,
    onError,
  });
};
